import { render } from "./CadastroCompetencias.vue?vue&type=template&id=c5e37374&scoped=true"
import script from "./CadastroCompetencias.vue?vue&type=script&lang=js"
export * from "./CadastroCompetencias.vue?vue&type=script&lang=js"

import "./CadastroCompetencias.vue?vue&type=style&index=0&id=c5e37374&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5e37374"]])

export default __exports__